import { Routes, Route, useLocation, useNavigate } from "react-router-dom";

import EpisodeSelectionMaster from '../../Pages/Master/EpisodeSelectionMaster/EpisodeSelectionMaster';
import PlaylistMaster from "../../Pages/Master/PlaylistMaster/PlaylistMaster";
import ConfigurationMaster from "../../Pages/Master/ConfigurationMaster/ConfigurationMaster";
import WikiMaster from "../../Pages/Master/WikiMaster/WikiMaster";
import CreatureMaster from "../../Pages/Master/CreatureMaster/CreatureMaster";
import HomeMaster from "../../Pages/Master/HomeMaster/HomeMaster";
import Faq from "../../Pages/Master/Faq/Faq";
import YoutubePlayer from "../../Components/YoutubePlayer/YoutubePlayer";
import Scene from "../../Components/Scene/Scene";
import * as routes from "../../Services/routeNames";
import { useEffect, useState } from "react";
import DiceMaster from "../../Pages/Master/DiceMaster/DiceMaster";
import { useSelector } from "react-redux";
import { IState } from "../../Store/reducer";
import './routesMaster.scss';
import { redirectWithBoolean } from "../../Components/RedirectPlayer/RedirectPlayer";
import { episodes } from "../../Services/episodes";

export default function RoutesMaster() {

    const playlistId = useSelector((state: IState) => state.master.playlistId);
    const [isInEpisodeOrConfig, setIsInEpisodeOrConfig] = useState<boolean>(false);
    const location = useLocation();
    const navigate = useNavigate();

    const { episodeNumber, sceneNumber, numberOfPlayers } = useSelector((state: IState) => state.master);

    useEffect(() => {
        setIsInEpisodeOrConfig(location.pathname === routes.EPISODE_MASTER_PATH 
            || location.pathname === routes.CONFIG_MASTER_PATH 
            || location.pathname === routes.WIKI_MASTER_PATH
            || location.pathname === routes.FAQ_MASTER_PATH)
    }, [location]);

    useEffect(() => {
        if (!isInEpisodeOrConfig) {
            redirectWithBoolean(!episodeNumber || !episodes[episodeNumber] || !episodes[episodeNumber].scene[sceneNumber] ||
                numberOfPlayers < 2 || numberOfPlayers > 6, routes.EPISODE_MASTER_PATH, navigate);
        }
    }, [isInEpisodeOrConfig, episodeNumber, sceneNumber, numberOfPlayers, navigate]);

    var classNames = [];

    if (!isInEpisodeOrConfig) {
        classNames.push("with-scene")
    }

    if (playlistId) {
        classNames.push("with-player")
    }

    return (
        <div className={classNames.join(" ")}>
            <Routes>
                <Route index element={<HomeMaster />} />
                <Route path={routes.EPISODE_MASTER_SUFFIX} element={<EpisodeSelectionMaster />} />
                <Route path={routes.CONFIG_MASTER_SUFFIX} element={<ConfigurationMaster />} />
                <Route path={routes.PLAYLIST_MASTER_SUFFIX} element={<PlaylistMaster />} />
                <Route path={routes.CREATURE_MASTER_SUFFIX} element={<CreatureMaster />} />
                <Route path={routes.WIKI_MASTER_SUFFIX} element={<WikiMaster />} />
                <Route path={routes.DICE_MASTER_SUFFIX} element={<DiceMaster />} />
                <Route path={routes.FAQ_MASTER_SUFFIX} element={<Faq />} />
            </Routes>
            <YoutubePlayer display={!isInEpisodeOrConfig} />
            <Scene display={!isInEpisodeOrConfig} />
        </div>
    );
}
